import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const a=t("saint_kitts_and_nevis",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 20.5L0 4.5L24 4.5L0 20.5Z"
                fill="#009739" />
            <path
                d="M24 4.5L24 20.5L0 20.5L24 4.5Z"
                fill="#C8102E" />
            <path
                d="M24 8.53809V4.5L17.9432 4.5L0 16.4619L0 20.5H6.05747L24 8.53809Z"
                fill="#FFCD00" />
            <path
                d="M24 7.38482V4.5H19.6734L0 17.6158L0 20.5H4.32658L24 7.38482Z"
                fill="black" />
            <path
                d="M8.32755 15.5232L8.89214 13.9968L7.5383 14.8993L6.26129 13.8906L6.7015 15.4574L5.34766 16.3606L6.9737 16.4257L7.41392 17.9925L7.97851 16.4661L9.60455 16.5319L8.32755 15.5232Z"
                fill="white" />
            <path
                d="M17.209 10.3128L18.835 10.3786L17.558 9.36986L18.1226 7.84345L16.7688 8.74601L15.4918 7.7373L15.932 9.30409L14.5781 10.2073L16.2042 10.2724L16.6444 11.8392L17.209 10.3128Z"
                fill="white" />
        </svg>
    `),p=t("saint_kitts_and_nevis_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92915)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-6 24.5L-6 0.5L30 0.5L-6 24.5Z"
                    fill="#009739" />
                <path
                    d="M30 0.5L30 24.5L-6 24.5L30 0.5Z"
                    fill="#C8102E" />
                <path
                    d="M30 6.55714V0.5L20.9148 0.5L-6 18.4429L-6 24.5H3.0862L30 6.55714Z"
                    fill="#FFCD00" />
                <path
                    d="M30 4.82723V0.5L23.5101 0.5L-6 20.1737V24.5H0.489866L30 4.82723Z"
                    fill="black" />
                <path
                    d="M8.17297 15.9117L9.01985 13.6221L6.98908 14.976L5.07358 13.4629L5.73389 15.8131L3.70312 17.1679L6.1422 17.2656L6.80251 19.6158L7.6494 17.3261L10.0885 17.4248L8.17297 15.9117Z"
                    fill="white" />
                <path
                    d="M18.2549 10.2099L20.6939 10.3086L18.7784 8.79552L19.6253 6.5059L17.5946 7.85974L15.679 6.34668L16.3394 8.69686L14.3086 10.0517L16.7477 10.1494L17.408 12.4995L18.2549 10.2099Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92915">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as SaintKittsAndNevis,p as SaintKittsAndNevisRounded};
